import {
    MENU_EXPAND,
    MENU_EXPAND_SUCCESS,
    MENU_EXPAND_ERROR,
    MENU_COLLAPSE,
    MENU_COLLAPSE_SUCCESS,
    MENU_COLLAPSE_ERROR
} from '../types';

export function expandMenuAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( expandMenu() );
        //Agrego la clase
        document.body.classList.remove('sidebar-toggled');
        //Llamo al dispatch
        dispatch( expandMenuSuccess(true) );
    }
}

const expandMenu = () => ({
    type: MENU_EXPAND,
    payload: true
});

const expandMenuSuccess = expandMenu => ({
    type: MENU_EXPAND_SUCCESS,
    payload: expandMenu
});

const expandMenuError = error => ({
    type: MENU_EXPAND_ERROR,
    payload: error
});

export function collapseMenuAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( collapseMenu() );
        //Agrego la clase
        document.body.classList.add('sidebar-toggled');
        //Llamo al dispatch
        dispatch( collapseMenuSuccess(false) );
    }
}

const collapseMenu = () => ({
    type: MENU_EXPAND,
    payload: true
});

const collapseMenuSuccess = collapseMenu => ({
    type: MENU_EXPAND_SUCCESS,
    payload: collapseMenu
});

const collapseMenuError = error => ({
    type: MENU_EXPAND_ERROR,
    payload: error
});